export interface ParsedVaultLink {
  linkText: string;
  target: string;
}

const markdownLinkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;
const wikiLinkPattern = /\[\[([^\]]+)\]\]/g;

export function normalizeVaultTarget(target: string) {
  const strippedDecorators = target
    .trim()
    .split('#')[0]
    .split('?')[0];

  const decoded = (() => {
    try {
      return decodeURIComponent(strippedDecorators);
    } catch {
      return strippedDecorators;
    }
  })();

  const cleaned = decoded
    .trim()
    .replace(/^\.\//, '')
    .replace(/^(\.\.\/)+/, '')
    .replace(/^\//, '');

  if (!cleaned) return '';
  if (cleaned.endsWith('.md')) return cleaned;
  return `${cleaned.replace(/\/$/, '')}.md`;
}

export function extractVaultLinks(markdown: string): ParsedVaultLink[] {
  const links: ParsedVaultLink[] = [];

  for (const match of markdown.matchAll(markdownLinkPattern)) {
    const linkText = match[1]?.trim();
    const target = normalizeVaultTarget(match[2] ?? '');
    if (linkText && target) {
      links.push({ linkText, target });
    }
  }

  for (const match of markdown.matchAll(wikiLinkPattern)) {
    const raw = match[1]?.trim();
    if (!raw) continue;
    links.push({ linkText: raw, target: normalizeVaultTarget(raw) });
  }

  return links;
}

export function wikiLinksToMarkdown(markdown: string) {
  return markdown.replace(wikiLinkPattern, (_, raw: string) => {
    const cleaned = raw.trim();
    return `[${cleaned}](${normalizeVaultTarget(cleaned)})`;
  });
}